import { render } from "./Machines.vue?vue&type=template&id=04cbf1e1&bindings={\"id\":\"props\",\"group\":\"props\",\"hasFilters\":\"options\",\"allFilters\":\"options\",\"searchPlaceholder\":\"options\",\"fetchData\":\"options\",\"expand\":\"options\",\"refresh\":\"options\"}"
import script from "./Machines.vue?vue&type=script&lang=js"
export * from "./Machines.vue?vue&type=script&lang=js"
script.render = render

export default script